var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.obj)?_c('div',{staticClass:"integration-sendgrid"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"})])
}]

export { render, staticRenderFns }